module.exports = __webpack_public_path__ + "media/mindwell-logo/mindwell-logo-new-22205668.svg";